export default "__VITE_ASSET__CYpHhd6E__"